<template>
  <svg
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_340_494)">
      <path
        d="M22.3132 22.8571L14.8713 12.0077L14.884 12.0179L21.594 4.2417H19.3517L13.8855 10.5709L9.54474 4.2417H3.66397L10.6117 14.371L10.6109 14.3702L3.2832 22.8571H5.52551L11.6026 15.8154L16.4324 22.8571H22.3132ZM8.65628 5.93401L19.0978 21.1648H17.3209L6.87089 5.93401H8.65628Z"
        fill="url(#paint0_linear_340_494)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_340_494"
        x1="3.2832"
        y1="4.2417"
        x2="38.3514"
        y2="36.5632"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="CurrentColor" />
        <stop offset="1" stop-color="CurrentColor" />
      </linearGradient>
      <clipPath id="clip0_340_494">
        <rect
          width="22"
          height="22"
          fill="CurrentColor"
          transform="translate(0 0.856934)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>